import type { CSSProperties } from 'react'
import type { TimelineEvent } from '@/shared/api'
import { Icon } from '@/shared/ui/icon'
import { eventToneIcon, eventToneToken } from '../model/timeline'
import s from './SystemEvent.module.css'

/**
 * Карточка системного события ленты (prototype/Prototype.dc.html:1491): «Бронь подтверждена»,
 * подпись перехода `pending → confirmed`, время.
 *
 * Цвет — из семантического `tone` контракта, а НЕ из статуса брони, которым карточка окрашена
 * в макете. Отступление осознанное, обоснование целиком — в `model/timeline.ts`.
 *
 * **Иконка выбирается по тону, а не всегда галка.** В макете иконка одна — галка (`check`,
 * 13×13, sw 2.4), потому что и событие там одно: «Бронь подтверждена». Скопировать это буквально
 * значило бы поставить **галку на «Бронь отменена»**, а галка утверждает «всё хорошо, готово».
 * На отменённой броне это прямая ложь о событии. Обоснование целиком — в `model/timeline.ts`,
 * у `eventToneIcon`. Геометрия (13×13, sw 2.4) и всё остальное — из макета без изменений.
 */
export function SystemEvent({ event }: { event: TimelineEvent }) {
  return (
    <div
      className={s.root}
      style={{ '--tint': eventToneToken(event.tone) } as CSSProperties}
    >
      <span className={s.tile}>
        <Icon name={eventToneIcon(event.tone)} size={13} strokeWidth={2.4} />
      </span>

      <span className={s.text}>
        <span className={s.title}>{event.title}</span>
        {/* `transitionLabel` в контракте необязателен — событие без перехода тоже валидно. */}
        {event.transitionLabel && <span className={s.transition}>{event.transitionLabel}</span>}
      </span>

      <span className={s.time}>{event.timeLabel}</span>
    </div>
  )
}
